<template>
  <div class="setting">
    <el-radio-group v-model="configType" @change="init">
      <el-radio-button label="0">平台</el-radio-button>
      <el-radio-button label="1">供应商</el-radio-button>
      <el-radio-button label="2">药房</el-radio-button>
    </el-radio-group>
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="20">
       <div v-show="configType==='0'">
          <el-form :inline="true" :model="platform" class="demo-form-inline" label-width="220px">
            <el-form-item label="异常处理好评前N参数">
              <el-input v-model="platform.top1" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="异常处理差评前N参数">
              <el-input v-model="platform.top2" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="保养处理好评前N参数">
              <el-input v-model="platform.top3" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="保养处理差评前N参数">
              <el-input v-model="platform.top4" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="设备生产指导计划系数">
              <el-input v-model="platform.top5" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="药杯生产指导计划系数">
              <el-input v-model="platform.top6" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="跳转代理商地址">
              <el-input v-model="platform.top7" style="width:400px" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="跳转药房地址">
              <el-input v-model="platform.top8"  style="width:400px" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="发药单价">
              <el-input v-model="platform.feeByDose"   size="medium" placeholder="请输入">
                <template slot="append">元/g</template>
              </el-input>
            </el-form-item>
            <el-form-item label="发药单价">
              <el-input v-model="platform.feeByCup"  size="medium" placeholder="请输入">
                <template slot="append"> 元/杯</template>
              </el-input>
            </el-form-item>
            <el-form-item label="发药单价">
              <el-input v-model="platform.feeByPrescription" size="medium" placeholder="请输入">
                <template slot="append">元/副</template>
              </el-input>
            </el-form-item>
            <el-form-item label="发药单价">
              <el-input v-model="platform.feeByPrescriptionDay" size="medium" placeholder="请输入">
                <template slot="append">元/天</template>
              </el-input>
            </el-form-item>
            <el-form-item label="超过未支付月份">
              <el-input v-model="platform.unpayMonth" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="参考月份数">
              <el-input v-model="platform.months" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="生产指数">
              <el-input v-model="platform.p" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="药房销售量排行分页">
              <el-input v-model="platform.pharmacyPage" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="药品销售量排行分页">
              <el-input v-model="platform.equipmentPage" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="configType==='1'">
          <el-form :inline="true" :model="operator" class="demo-form-inline" label-width="220px">
            <el-form-item label="异常处理好评前N参数1">
              <el-input v-model="operator.top1" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="异常处理差评前N参数">
              <el-input v-model="operator.top2" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="保养处理好评前N参数">
              <el-input v-model="operator.top3" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="保养处理差评前N参数">
              <el-input v-model="operator.top4" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="设备生产指导计划系数">
              <el-input v-model="operator.top5" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="药杯生产指导计划系数">
              <el-input v-model="operator.top6" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="其他">
              <el-input v-model="operator.top7" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="configType==='2'">
          <el-form :inline="true" :model="pharmacy" class="demo-form-inline" label-width="220px">
            <el-form-item label="异常处理好评前N参数2">
              <el-input v-model="pharmacy.top1" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="异常处理差评前N参数">
              <el-input v-model="pharmacy.top2" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="保养处理好评前N参数">
              <el-input v-model="pharmacy.top3" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="保养处理差评前N参数">
              <el-input v-model="pharmacy.top4" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="设备生产指导计划系数">
              <el-input v-model="pharmacy.top5" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="药杯生产指导计划系数">
              <el-input v-model="pharmacy.top6" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="其他">
              <el-input v-model="pharmacy.top7" size="medium" placeholder="请输入"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div style="text-align: center">
      <el-button type="primary" size="medium" @click="save()">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "setting",
  data() {
    return {
      platform: {
        top1:'',
        top2:'',
        top3:'',
        top4:'',
        top5:'',
        top6:'',
        top7:'',
        top8:'',
        unpayMonth:'',
        feeByDose:'',
        feeByCup:'',
        feeByPrescription:'',
        feeByPrescriptionDay:'',
        months:'',
        p:'',
        pharmacyPage:'',
        equipmentPage:'',
      },
      operator:{
        top1:'',
        top2:'',
        top3:'',
        top4:'',
        top5:'',
        top6:'',
        top7:'',
      },
      pharmacy:{
        top1:'',
        top2:'',
        top3:'',
        top4:'',
        top5:'',
        top6:'',
        top7:'',
      },
      configType:'0',
    }
  },
  components: {
    //someComponent
  },
  methods: {
    //
    init(){
      let data={
        ConfigType:this.configType
      }
      this.axios
          .get("/api/ParamConfig/GetOtherConfig",{params: data}).then((res) => {
            if(res){
              if(this.configType==='0'){
                this.platform=JSON.parse(res)
                window.utils.storage.setter("GetOtherConfig", res);
              }else if(this.configType==='1'){
                this.operator=JSON.parse(res)
              }else {
                this.pharmacy=JSON.parse(res)
              }
            }
      })
    },
    save(){
      let dataType=[]
      if(this.configType==='0'){
        dataType=this.platform
      }else if(this.configType==='1'){
        dataType=this.operator
      }else {
        dataType=this.pharmacy
      }
      let data={
       configType: Number(this.configType),
       data:JSON.stringify(dataType)
      }
      this.axios.post("/api/ParamConfig",data).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.init()
      })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.setting {

}
</style>